import React from 'react'
import styled from './SendOpinionPopup.module.css'
import clip from '../img/icon/clip.svg'
// 수첩정보 팝업
const SendOpinionPopup = (props:any) => {
    const { popRef, showSendOpinionPopup, setSendOpinionPopup, coordinates } = props

    return (
        <div className={styled.send_opinion_pop}
            ref={popRef}
            style={{ 
            bottom: `50px`, 
            right: `50px`, 
            display: showSendOpinionPopup ? 'block' : 'none' }}>
            <p className={styled.tit}>
                <span className={styled.title}>소견서 전송</span>
                <a href="#" className={styled.close_btn} onClick={()=>setSendOpinionPopup(false)}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8.94028 7.99988L13.1403 3.80655C13.2658 3.68101 13.3363 3.51075 13.3363 3.33321C13.3363 3.15568 13.2658 2.98542 13.1403 2.85988C13.0147 2.73434 12.8445 2.66382 12.667 2.66382C12.4894 2.66382 12.3192 2.73434 12.1936 2.85988L8.00029 7.05988L3.80695 2.85988C3.68142 2.73434 3.51115 2.66382 3.33362 2.66382C3.15608 2.66382 2.98582 2.73434 2.86028 2.85988C2.73475 2.98542 2.66422 3.15568 2.66422 3.33321C2.66422 3.51075 2.73475 3.68101 2.86028 3.80655L7.06029 7.99988L2.86028 12.1932C2.7978 12.2552 2.7482 12.3289 2.71436 12.4102C2.68051 12.4914 2.66309 12.5785 2.66309 12.6665C2.66309 12.7546 2.68051 12.8417 2.71436 12.9229C2.7482 13.0042 2.7978 13.0779 2.86028 13.1399C2.92226 13.2024 2.99599 13.252 3.07723 13.2858C3.15847 13.3197 3.24561 13.3371 3.33362 13.3371C3.42163 13.3371 3.50876 13.3197 3.59 13.2858C3.67124 13.252 3.74498 13.2024 3.80695 13.1399L8.00029 8.93988L12.1936 13.1399C12.2556 13.2024 12.3293 13.252 12.4106 13.2858C12.4918 13.3197 12.5789 13.3371 12.667 13.3371C12.755 13.3371 12.8421 13.3197 12.9233 13.2858C13.0046 13.252 13.0783 13.2024 13.1403 13.1399C13.2028 13.0779 13.2524 13.0042 13.2862 12.9229C13.3201 12.8417 13.3375 12.7546 13.3375 12.6665C13.3375 12.5785 13.3201 12.4914 13.2862 12.4102C13.2524 12.3289 13.2028 12.2552 13.1403 12.1932L8.94028 7.99988Z" fill="black"/>
                </svg></a>
            </p>
            <div className={styled.input}>
                <p> 받는사람</p>
                <input type="text" placeholder="이메일을 입력해주세요"/>
            </div>
            <div className={styled.input}>
                <p> 제목 </p>
                <input type="text" placeholder=""/>
            </div>
            <div className={styled.input}>
                <p> 내용 </p>
                <textarea placeholder=""/>
            </div>
            <div className={styled.icon_list}>
                <div>
                    <img src={clip} alt="icon"/>
                    <img src={clip} alt="icon"/>
                    <img src={clip} alt="icon"/>
                    <img src={clip} alt="icon"/>
                    <img src={clip} alt="icon"/>
                    <img src={clip} alt="icon"/>
                    <img src={clip} alt="icon"/>
                    <img src={clip} alt="icon"/>
                </div>
                 <div> 
                    <img src={clip} alt="icon"/>
                    <img src={clip} alt="icon"/>
                 </div>
            </div>
            <div className={styled.send}>
                <button> 전송하기 </button>
            </div>
        </div>
    )
}

export default SendOpinionPopup